export const SubmitButtonStrings = {
    LOGIN: "Sign In",
    SIGNUP: "Create Account",
    RECOVER: "Reset old password",
    DEFINE: "Save Password",
    CREATE: "Create Account"
};
